import { useState } from "react";

// The 4 fixed sections always walk financial -> customer -> operations ->
// people (08-fe-handoff.md §1) and there are always exactly 4 of them, so a
// positional color assignment is safe and doesn't need to know the sections'
// exact key spelling - same CanvasBand modifier classes Strategy Canvas uses
// (CanvasBand.scss's --teal/--dark/--core/--dna), reused here for the same
// "same design as canvas" visual parity the rest of this screen goes for.
const SECTION_COLORS = ["teal", "dark", "core", "dna"];

export const getSectionColor = (index) =>
  SECTION_COLORS[index % SECTION_COLORS.length];

/**
 * Owns "where the coach lands": which sections are folded shut, and which
 * single item's accordion is open. Simplified one-level version of Strategy
 * Canvas's useInitialCanvasFocus (StrategyCanvasStructure.js) - EXW's 4
 * sections are already the top-level grouping (no nested band/section/group
 * tree to flatten, per D4), so there's only one level to prime instead of
 * two.
 *
 * Opens the FIRST section (by `sequence`) rather than the last, unlike
 * Canvas's deliberate DNA-first choice - EXW's sections have no equivalent
 * narrative reason to start at the end; financial_wig first matches the
 * walk order the backend itself uses.
 *
 * Primes once per mount, not on every `sections` change, and sets state
 * during render rather than in an effect - both choices preserved from
 * Canvas's version for the same reasons (see CLAUDE.md): an effect would
 * paint one frame with everything open first, and `primed` has to be state
 * rather than a ref so StrictMode's double render-invoke lands on the same
 * result both passes.
 */
export const useInitialSectionFocus = (sections) => {
  const [collapsedSections, setCollapsedSections] = useState(() => new Set());
  const [expandedItemId, setExpandedItemId] = useState(null);
  const [primed, setPrimed] = useState(false);

  if (!primed && sections.length) {
    setPrimed(true);

    const [first, ...rest] = sections;
    setCollapsedSections(
      new Set(rest.map((section) => section.section_key)),
    );
    setExpandedItemId(
      first?.items?.[0]?.execution_blueprint_item_id ?? null,
    );
  }

  return {
    collapsedSections,
    setCollapsedSections,
    expandedItemId,
    setExpandedItemId,
  };
};
